import { styled, TextField, TextFieldPropsSizeOverrides } from '@mui/material';
import { token } from "../../shared/theme";
import { useField } from 'formik';

export interface TextInputProps {
    type?: string;
    name: string;
    label?: string;
    disabled?: boolean;
    autocomplete?: string;
    required?: boolean;
    helperText?: string;
    placeholder?: string;
    fullwidth?: boolean;
    multiline?: boolean;
    variant?: "standard" | "filled" | "outlined"
}

const StyledField = styled(TextField)(({ theme }) => ({
    '.MuiInputBase-root' : {
        background: token.color.form.background.normal
    }
  }));

  const TextInput = (props: TextInputProps) => {
    const { disabled, label } = props;
    const [field, meta] = useField(props.name);
    return <>
        <StyledField
            { ...field }
            required={props.required}
            fullWidth={props.fullwidth ?? true}
            variant={props.variant}
            disabled={disabled}
            label={label}
            type={props.type}
            autoComplete={props.autocomplete}
            helperText={meta.error ?? props.helperText}
            error={(meta.touched && (meta.error !== undefined))}
            placeholder={props.placeholder}
            multiline={props.multiline}
        />
    </>
}

export interface TextInputControlledProps {
    type?: string;
    label?: string;
    disabled?: boolean;
    autocomplete?: string;
    required?: boolean;
    helperText?: string;
    placeholder?: string;
    fullwidth?: boolean;
    variant?: "standard" | "filled" | "outlined"
    size?: "small" | "medium"
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TextInputControlled = (props: TextInputControlledProps) => {
    const { disabled, label } = props;
    return <>
        <StyledField
            required={props.required}
            fullWidth={props.fullwidth ?? true}
            variant={props.variant}
            disabled={disabled}
            label={label}
            type={props.type}
            autoComplete={props.autocomplete}
            helperText={props.helperText}
            placeholder={props.placeholder}
            defaultValue={props.value}
            onChange={props.onChange}
            size={props.size}
        />
    </>
}

export default TextInput;